import { getEpisodeFromVocabSessionId } from '../../../lib/workshopUtility';

export default {
  intro: {
    vo_olivia_v01: {
      name: 'S3_hub_onboarding_Olivia_V01',
      file: 'S3_hub_onboarding_Olivia_V01.mp3',
      path: 'AQUA_METAGAME/quests/season3/audio/',
    },
    vo_olivia_v02: {
      name: 'S3_hub_onboarding_Olivia_V02',
      file: 'S3_hub_onboarding_Olivia_V02.mp3',
      path: 'AQUA_METAGAME/quests/season3/audio/',
    },
  },
  firstGameMastered: {
    vo_olivia_v03: {
      name: 'S3_hub_onboarding_Olivia_V03',
      file: 'S3_hub_onboarding_Olivia_V03.mp3',
      path: 'AQUA_METAGAME/quests/season3/audio/',
    },
    vo_olivia_v04: {
      name: 'S3_hub_onboarding_Olivia_V04',
      file: 'S3_hub_onboarding_Olivia_V04.mp3',
      path: 'AQUA_METAGAME/quests/season3/audio/',
    },
  },
  secondGameMastered: {
    vo_olivia_v05: {
      name: 'S3_hub_onboarding_Olivia_V05',
      file: 'S3_hub_onboarding_Olivia_V05.mp3',
      path: 'AQUA_METAGAME/quests/season3/audio/',
    },
    vo_olivia_v06: {
      name: 'S3_hub_onboarding_Olivia_V06',
      file: 'S3_hub_onboarding_Olivia_V06.mp3',
      path: 'AQUA_METAGAME/quests/season3/audio/',
    },
  },
};

export const getTransmitterAudioMapByVocabSession = (session = '') => {
  // episode = 01, 02..15, 16
  const episode = getEpisodeFromVocabSessionId(session);
  switch (session) {
    case '301-1': {
      // quest 1 is onboarding quest only
      return {
        S3_hub_onboarding_Olivia_V07: {
          name: 'S3_hub_onboarding_Olivia_V07',
          file: 'S3_hub_onboarding_Olivia_V07.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V08: {
          name: 'S3_hub_onboarding_Olivia_V08',
          file: 'S3_hub_onboarding_Olivia_V08.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V09: {
          name: 'S3_hub_onboarding_Olivia_V09',
          file: 'S3_hub_onboarding_Olivia_V09.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V10: {
          name: 'S3_hub_onboarding_Olivia_V10',
          file: 'S3_hub_onboarding_Olivia_V10.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V11: {
          name: 'S3_hub_onboarding_Olivia_V11',
          file: 'S3_hub_onboarding_Olivia_V11.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    case '309-1': {
      // quest 9 may be both onboarding and regular quest so need both resources
      return {
        S3_hub_onboarding_Olivia_V07: {
          name: 'S3_hub_onboarding_Olivia_V07',
          file: 'S3_hub_onboarding_Olivia_V07.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V08: {
          name: 'S3_hub_onboarding_Olivia_V08',
          file: 'S3_hub_onboarding_Olivia_V08.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V09: {
          name: 'S3_hub_onboarding_Olivia_V09',
          file: 'S3_hub_onboarding_Olivia_V09.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V10: {
          name: 'S3_hub_onboarding_Olivia_V10',
          file: 'S3_hub_onboarding_Olivia_V10.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_onboarding_Olivia_V11: {
          name: 'S3_hub_onboarding_Olivia_V11',
          file: 'S3_hub_onboarding_Olivia_V11.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V01`]: {
          name: `S3_hub_ep${episode}_Olivia_V01`,
          file: `S3_hub_ep${episode}_Olivia_V01.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V02`]: {
          name: `S3_hub_ep${episode}_Olivia_V02`,
          file: `S3_hub_ep${episode}_Olivia_V02.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V03`]: {
          name: `S3_hub_ep${episode}_Olivia_V03`,
          file: `S3_hub_ep${episode}_Olivia_V03.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V04`]: {
          name: `S3_hub_ep${episode}_Olivia_V04`,
          file: `S3_hub_ep${episode}_Olivia_V04.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    case '302-1':
    case '303-1':
    case '304-1':
    case '305-1':
    case '306-1':
    case '307-1':
    case '308-1':
    case '310-1':
    case '311-1':
    case '312-1':
    case '313-1':
    case '314-1':
    case '315-1':
    case '316-1':
    {
      return {
        [`S3_hub_ep${episode}_Olivia_V01`]: {
          name: `S3_hub_ep${episode}_Olivia_V01`,
          file: `S3_hub_ep${episode}_Olivia_V01.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V02`]: {
          name: `S3_hub_ep${episode}_Olivia_V02`,
          file: `S3_hub_ep${episode}_Olivia_V02.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V03`]: {
          name: `S3_hub_ep${episode}_Olivia_V03`,
          file: `S3_hub_ep${episode}_Olivia_V03.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V04`]: {
          name: `S3_hub_ep${episode}_Olivia_V04`,
          file: `S3_hub_ep${episode}_Olivia_V04.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    case '301-2': {
      return {
        /* Next 4 audio are hardcoded for Demo Tool because episode = 03 there */
        S3_hub_ep01_Olivia_V01: {
          name: 'S3_hub_ep01_Olivia_V01',
          file: 'S3_hub_ep01_Olivia_V01.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V02: {
          name: 'S3_hub_ep01_Olivia_V02',
          file: 'S3_hub_ep01_Olivia_V02.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V03: {
          name: 'S3_hub_ep01_Olivia_V03',
          file: 'S3_hub_ep01_Olivia_V03.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V04: {
          name: 'S3_hub_ep01_Olivia_V04',
          file: 'S3_hub_ep01_Olivia_V04.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V01`]: {
          name: `S3_hub_ep${episode}_Olivia_V01`,
          file: `S3_hub_ep${episode}_Olivia_V01.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V02`]: {
          name: `S3_hub_ep${episode}_Olivia_V02`,
          file: `S3_hub_ep${episode}_Olivia_V02.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V03`]: {
          name: `S3_hub_ep${episode}_Olivia_V03`,
          file: `S3_hub_ep${episode}_Olivia_V03.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V04`]: {
          name: `S3_hub_ep${episode}_Olivia_V04`,
          file: `S3_hub_ep${episode}_Olivia_V04.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    case '309-2': {
      // quest 9 may be both onboarding and regular quest so need both resources
      return {
        S3_hub_ep01_Olivia_V01: {
          name: 'S3_hub_ep01_Olivia_V01',
          file: 'S3_hub_ep01_Olivia_V01.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V02: {
          name: 'S3_hub_ep01_Olivia_V02',
          file: 'S3_hub_ep01_Olivia_V02.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V03: {
          name: 'S3_hub_ep01_Olivia_V03',
          file: 'S3_hub_ep01_Olivia_V03.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V04: {
          name: 'S3_hub_ep01_Olivia_V04',
          file: 'S3_hub_ep01_Olivia_V04.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V05`]: {
          name: `S3_hub_ep${episode}_Olivia_V05`,
          file: `S3_hub_ep${episode}_Olivia_V05.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V06`]: {
          name: `S3_hub_ep${episode}_Olivia_V06`,
          file: `S3_hub_ep${episode}_Olivia_V06.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V07`]: {
          name: `S3_hub_ep${episode}_Olivia_V07`,
          file: `S3_hub_ep${episode}_Olivia_V07.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V08`]: {
          name: `S3_hub_ep${episode}_Olivia_V08`,
          file: `S3_hub_ep${episode}_Olivia_V08.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    case '302-2':
    case '303-2':
    case '304-2':
    case '305-2':
    case '306-2':
    case '307-2':
    case '308-2':
    case '310-2':
    case '311-2':
    case '312-2':
    case '313-2':
    case '314-2':
    case '315-2':
    case '316-2':
    {
      return {
        [`S3_hub_ep${episode}_Olivia_V05`]: {
          name: `S3_hub_ep${episode}_Olivia_V05`,
          file: `S3_hub_ep${episode}_Olivia_V05.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V06`]: {
          name: `S3_hub_ep${episode}_Olivia_V06`,
          file: `S3_hub_ep${episode}_Olivia_V06.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V07`]: {
          name: `S3_hub_ep${episode}_Olivia_V07`,
          file: `S3_hub_ep${episode}_Olivia_V07.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V08`]: {
          name: `S3_hub_ep${episode}_Olivia_V08`,
          file: `S3_hub_ep${episode}_Olivia_V08.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    case '309-3':
    {
      // quest 9 may be both onboarding and regular quest so need both resources
      return {
        S3_hub_ep01_Olivia_V05: {
          name: 'S3_hub_ep01_Olivia_V05',
          file: 'S3_hub_ep01_Olivia_V05.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V06: {
          name: 'S3_hub_ep01_Olivia_V06',
          file: 'S3_hub_ep01_Olivia_V06.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V07: {
          name: 'S3_hub_ep01_Olivia_V07',
          file: 'S3_hub_ep01_Olivia_V07.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V08: {
          name: 'S3_hub_ep01_Olivia_V08',
          file: 'S3_hub_ep01_Olivia_V08.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V09`]: {
          name: `S3_hub_ep${episode}_Olivia_V09`,
          file: `S3_hub_ep${episode}_Olivia_V09.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V10`]: {
          name: `S3_hub_ep${episode}_Olivia_V10`,
          file: `S3_hub_ep${episode}_Olivia_V10.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V11`]: {
          name: `S3_hub_ep${episode}_Olivia_V11`,
          file: `S3_hub_ep${episode}_Olivia_V11.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V12`]: {
          name: `S3_hub_ep${episode}_Olivia_V12`,
          file: `S3_hub_ep${episode}_Olivia_V12.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    case '301-3':
    case '302-3':
    case '303-3':
    case '304-3':
    case '305-3':
    case '306-3':
    case '307-3':
    case '308-3':
    case '310-3':
    case '311-3':
    case '312-3':
    case '313-3':
    case '314-3':
    case '315-3':
    case '316-3':
    {
      return {
        /* Next 4 audio are hardcoded for Demo Tool because episode = 03 there */
        S3_hub_ep01_Olivia_V05: {
          name: 'S3_hub_ep01_Olivia_V05',
          file: 'S3_hub_ep01_Olivia_V05.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V06: {
          name: 'S3_hub_ep01_Olivia_V06',
          file: 'S3_hub_ep01_Olivia_V06.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V07: {
          name: 'S3_hub_ep01_Olivia_V07',
          file: 'S3_hub_ep01_Olivia_V07.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        S3_hub_ep01_Olivia_V08: {
          name: 'S3_hub_ep01_Olivia_V08',
          file: 'S3_hub_ep01_Olivia_V08.mp3',
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V09`]: {
          name: `S3_hub_ep${episode}_Olivia_V09`,
          file: `S3_hub_ep${episode}_Olivia_V09.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V10`]: {
          name: `S3_hub_ep${episode}_Olivia_V10`,
          file: `S3_hub_ep${episode}_Olivia_V10.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V11`]: {
          name: `S3_hub_ep${episode}_Olivia_V11`,
          file: `S3_hub_ep${episode}_Olivia_V11.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
        [`S3_hub_ep${episode}_Olivia_V12`]: {
          name: `S3_hub_ep${episode}_Olivia_V12`,
          file: `S3_hub_ep${episode}_Olivia_V12.mp3`,
          path: 'AQUA_METAGAME/quests/season3/audio/',
        },
      };
    }
    default:
      return {};
  }
};

export const curiosoPickerSfx = {
  sfx_curioso_options_appear_01: {
    name: 'sfx_curioso_options_appear_01',
    file: 'sfx_curioso_options_appear_01.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_appear_02: {
    name: 'sfx_curioso_options_appear_02',
    file: 'sfx_curioso_options_appear_02.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_appear_03: {
    name: 'sfx_curioso_options_appear_03',
    file: 'sfx_curioso_options_appear_03.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_inspire_01: {
    name: 'sfx_curioso_options_inspire_01',
    file: 'sfx_curioso_options_inspire_01.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_inspire_02: {
    name: 'sfx_curioso_options_inspire_02',
    file: 'sfx_curioso_options_inspire_02.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_inspire_03: {
    name: 'sfx_curioso_options_inspire_03',
    file: 'sfx_curioso_options_inspire_03.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_shape_01: {
    name: 'sfx_curioso_options_shape_01',
    file: 'sfx_curioso_options_shape_01.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_shape_02: {
    name: 'sfx_curioso_options_shape_02',
    file: 'sfx_curioso_options_shape_02.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_options_shape_03: {
    name: 'sfx_curioso_options_shape_03',
    file: 'sfx_curioso_options_shape_03.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_orb_floating: {
    name: 'sfx_curioso_orb_floating',
    file: 'sfx_curioso_orb_floating.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_orb_hatching: {
    name: 'sfx_curioso_orb_hatching',
    file: 'sfx_curioso_orb_hatching.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_orb_tap: {
    name: 'sfx_curioso_orb_tap',
    file: 'sfx_curioso_orb_tap.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_question_shape: {
    name: 'sfx_curioso_question_shape',
    file: 'sfx_curioso_question_shape.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_question_inspire: {
    name: 'sfx_curioso_question_inspire',
    file: 'sfx_curioso_question_inspire.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_question_appear: {
    name: 'sfx_curioso_question_appear',
    file: 'sfx_curioso_question_appear.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_curioso_questionset_answer_tap: {
    name: 'sfx_curioso_questionset_answer_tap',
    file: 'sfx_curioso_questionset_answer_tap.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  sfx_hub_open_collection: {
    name: 'sfx_hub_open_collection',
    file: 'sfx_hub_open_collection.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
};

export const workshopSfx = {
  intro_background: {
    name: 'sfx_hub_workshop_intro_first',
    file: 'sfx_hub_workshop_intro_first.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  zoom_in: {
    name: 'sfx_hub_zoom_in',
    file: 'sfx_hub_zoom_in.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  battery_cta: {
    name: 'sfx_hub_glyphmachine_cta',
    file: 'sfx_hub_glyphmachine_cta.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  transmitter_output: {
    name: 'sfx_hub_radio_output',
    file: 'sfx_hub_radio_output.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  transmitter_cta: {
    name: 'sfx_hub_radio_cta',
    file: 'sfx_hub_radio_cta.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  portal_cta: {
    name: 'sfx_hub_portal_cta',
    file: 'sfx_hub_portal_cta.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  portal_output: {
    name: 'sfx_hub_portal_output',
    file: 'sfx_hub_portal_output.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  notification_launch: {
    name: 'notification_launch',
    file: 'wildplanet_tuning_in.mp3',
    path: 'wild_planet/audio/sfx/',
  },
  game_early_exit: {
    name: 'game_early_exit',
    file: 'wildplanet_negative.mp3',
    path: 'wild_planet/audio/sfx/',
  },
  codex_cta: {
    name: 'sfx_hub_book_cta',
    file: 'sfx_hub_book_cta.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  mobile_intro: {
    name: 'sfx_hub_open_progress',
    file: 'sfx_hub_open_progress.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  quest_complete_launch: {
    name: 'sfx_hub_quest_complete',
    file: 'sfx_hub_quest_complete.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  all_quests_complete_launch: {
    name: 'sfx_hub_quest_complete',
    file: 'mysterious_sfx.mp3',
    path: 'AQUA_METAGAME/quests/season2/audio/',
  },
  battery_discharged: {
    name: 'sfx_science_sounds_02.mp3',
    file: 'sfx_science_sounds_02.mp3',
    path: 'AQUA_METAGAME/quests/season2/audio/',
  },
  close_reading_launch: {
    name: 'sfx_close_reading_launch.mp3',
    file: 'sfx_close_reading_launch.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  ereader_launch: {
    name: 'sfx_battery_pop.mp3',
    file: 'sfx_battery_pop.mp3',
    path: 'AQUA_METAGAME/quests/season2/audio/',
  },
  new_reward: {
    name: 'sfx_reward',
    file: 'wildplanet_positive.mp3',
    path: 'wild_planet/audio/sfx/',
  },
  open_collection: {
    name: 'sfx_confirm_reward',
    file: 'wildplanet_tuning_in.mp3',
    path: 'wild_planet/audio/sfx/',
  },
  skill_game_launch: {
    name: 'sfx_skill_game_launch',
    file: 'Panel_sfx.mp3',
    path: 'AQUA_METAGAME/quests/season2/audio/',
  },
  curioso_alert: {
    name: 'sfx_door_glow_loop.mp3',
    file: 'sfx_door_glow_loop_short.mp3',
    path: 'AQUA_METAGAME/quests/season2/audio/',
  },
  collection_select: {
    name: 'codex_sfx_tag.mp3',
    file: 'codex_sfx_tag.mp3',
    path: 'codex/audio/',
  },
  weekly_usage_celebration: {
    name: 'sfx_hub_confetti',
    file: 'sfx_hub_confetti.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
};

export const workshopMusic = {
  theme2: {
    name: 'music_hub_workshop_theme_zephraya',
    file: 'music_hub_workshop_theme_zephraya.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  theme6: {
    name: 'music_hub_workshop_theme_cimera',
    file: 'music_hub_workshop_theme_cimera.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  theme9: {
    name: 'music_hub_workshop_theme_granfolie',
    file: 'music_hub_workshop_theme_granfolie.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  theme13: {
    name: 'music_hub_workshop_theme_dworp',
    file: 'music_hub_workshop_theme_dworp.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
  ambient: {
    name: 'sfx_hub_workshop_intro_returning',
    file: 'sfx_hub_workshop_intro_returning.mp3',
    path: 'AQUA_METAGAME/quests/season3/audio/',
  },
};
